import styles from '../styles/retailersmodal.module.scss';

import noImage from '../assets/no_image.png';

import { Image } from '@aws-amplify/ui-react';
import { ICampaign, IRetailer } from '../models/Campaign';

const RetailersModal = ({ showModal, toggleModal, filteredRetailers, campaignData }: PropTypes) => {
  const openRetailerPage = (url: string) => {
    window?.open(url);
  };

  return (
    <>
      {showModal && (
        <div className={styles.retailers_modal}>
          <div className={styles.close_button} onClick={toggleModal}>
            <span title="Close" style={{ color: `${campaignData?.ButtonColor || '#597ef7'}` }}>
              ⓧ
            </span>
          </div>
          <div className={styles.retailers_list}>
            {filteredRetailers?.map((item: IRetailer, i: number) => (
              <Image
                key={i}
                src={item.LogoUrl || noImage.src}
                className={styles.retailers_content}
                title="Participating Retailer(s)"
                alt="logo"
                width="90px"
                height="90px"
                onClick={() => openRetailerPage(item.Url)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

interface PropTypes {
  showModal: boolean;
  toggleModal: () => void;
  filteredRetailers?: IRetailer[];
  campaignData?: ICampaign;
}

export default RetailersModal;
